import { makeAutoObservable } from 'mobx';
import {AdminSiderMenuItem, AdminSiderStoreInterface} from "utils/interface";
import {postRequest} from "utils/axios";
import {GET_ADMIN_SIDER_STORE_URL} from "utils/constantsApi";
import {REQUEST_API_CODE_ENUM} from "utils/constants";

const defaultAdminSiderStoreDate: AdminSiderStoreInterface = {
    adminSiderMenuList: [
        {
            id: '1',
            type: 'static',
            parentId: '0',
            icon: 1,
            applicationName: '首页',
            url: '/admin/index',
            magicId: '',
            sort: "0"
        },
        {
            id: '5',
            type: 'static',
            parentId: '0',
            icon: 1,
            applicationName: '考勤管理',
            url: '',
            magicId: '',
            sort: "1"
        },
        {
            id: '6',
            type: 'static',
            parentId: '5',
            icon: 1,
            applicationName: '考勤列表',
            url: '/admin/workFlow',
            magicId: '',
            sort: "1"
        },
        {
            id: '7',
            type: 'static',
            parentId: '5',
            icon: 1,
            applicationName: '考勤统计',
            url: '/admin/infoChart',
            magicId: '',
            sort: "1"
        },
        {
            id: '2',
            type: 'static',
            parentId: '0',
            icon: 1,
            applicationName: '系统设置',
            url: '',
            magicId: '',
            sort: "1"
        },
        {
            id: '3',
            type: 'static',
            parentId: '2',
            icon: 1,
            applicationName: '系统设置',
            url: '/admin/systemConfig',
            magicId: '',
            sort: "0"
        },
        {
            id: '4',
            type: 'static',
            parentId: '2',
            icon: 1,
            applicationName: '人员管理',
            url: '/admin/personalConfig',
            magicId: '',
            sort: "0"
        },
    ],
    getAdminSiderMenuListLoading: false

}
class Store {
    adminSiderMenuList: AdminSiderMenuItem[];
    getAdminSiderMenuListLoading: boolean

    constructor(adminSiderStore: AdminSiderStoreInterface) {
        makeAutoObservable(
            this,
            {

            },
            {
                autoBind:true
            }
        );
        this.adminSiderMenuList = adminSiderStore.adminSiderMenuList
        this.getAdminSiderMenuListLoading = adminSiderStore.getAdminSiderMenuListLoading
    }

    setAdminSiderMenuList(path: AdminSiderMenuItem[]): void {
        this.adminSiderMenuList = path;
    }
    async getAdminSiderStore() {
        this.getAdminSiderMenuListLoading = true
        try {
            const res = await postRequest(GET_ADMIN_SIDER_STORE_URL, {})
            if (res?.code === REQUEST_API_CODE_ENUM.SUCCESS) {
                this.setAdminSiderMenuList(res?.data?.applicationList || [])
            }
        } catch (e) {

        }
        this.getAdminSiderMenuListLoading = false
    }

}

const AdminSiderStore = new Store(defaultAdminSiderStoreDate);

export default AdminSiderStore;